import { MakeCall } from './createMakeCall';

const deleteListingPhoto =
  (makeCall: MakeCall) => (listingId: number, photoId: number) =>
    makeCall<undefined>(
      'DELETE',
      `/api/v2/listing/${listingId}/photo/${photoId}`,
    );
export { deleteListingPhoto };
